const EligibilityFaqContent = [
  {
    title: 'What is required from me to be able to drive with Autzu?',
    info: [
      {
        text: {
          plaintext: 'Must be 21+ years of age'
        }
      },
      {
        text: {
          plaintext:
            'Have a valid full Ontario driver’s license (Class G or above)'
        }
      },
      {
        text: {
          plaintext:
            'Have an active rideshare driver account (such as Uber Driver) '
        }
      }
    ]
  },
  {
    title: 'What is a PTC license?',
    info: [
      {
        pretext:
          "A PTC (Private Transportation Company) license refers to a license granted to drivers associated with ride-sharing companies. It's a regulatory measure introduced in certain regions to ensure that rideshare drivers meet specific safety and operational standards. "
      },
      {
        pretext:
          "You would require a PTC license to drive with Autzu if you're planning to receive passenger trips in areas like Toronto, Mississauga, Scarborough, and Oakville within Ontario, a PTC license is mandatory."
      },
      {
        link: {
          leadingText: 'To get your PTC license, you must complete the ',
          title: 'mandatory Toronto Driver Training program',
          href:
            'https://www.uber.com/ca/en/drive/requirements/training/?cityID=toronto',
          trailingText: ' at one of the accredited schools.'
        }
      }
    ]
  },
  {
    title:
      'Can I drive if I have an international/out of province license?',
    info: [
      {
        pretext:
          'To drive with Autzu in Toronto, you must have an Ontario driver’s license (Class G or above). We recommend that you exchange your out-of-province or international license before registering for an account with us. '
      },
      {
        link: {
          leadingText:
            'In Ontario, you can obtain your license 60 days after you’ve moved to the province. For more information on how you can switch your license from another province, visit ',
          title: 'Service Ontario',
          href:
            'https://www.ontario.ca/page/exchange-out-province-drivers-licence',
          trailingText: '.'
        }
      }
    ]
  }
];

export default EligibilityFaqContent;



// WEBPACK FOOTER //
// ./src/components/Static/NewGeneralFaq/EligibilityFaqContent.js